/**
 * Narumigaoka Kindergarten - Main JavaScript
 */

// Import modules
// import './grid-overlay'; // DEV ONLY: design grid overlay (keys: G / F / H). Keep commented on production.
import './navigation';
import './tabs';
import './accordion';
import './video-modal';
import initYearFilter from './year-filter';

// DOM ready
document.addEventListener('DOMContentLoaded', () => {
  initYearFilter();

  // Support Programs Slider
  const track   = document.getElementById('supportProgramsTrack');
  const dotsWrap = document.getElementById('supportProgramsDots');
  const wrap    = track && track.closest('.support-programs__slider-wrap');

  if (track && wrap) {
    const cards      = Array.from(track.children);
    const prevBtn    = wrap.querySelector('.support-programs__nav--prev');
    const nextBtn    = wrap.querySelector('.support-programs__nav--next');
    let   current    = 0;

    const getSPV = () => window.innerWidth >= 1200 ? 3.5 : window.innerWidth >= 768 ? 2.2 : 1.2;

    const getCardW = () => {
      if (!cards.length) return 0;
      const style = getComputedStyle(track);
      const gap   = parseFloat(style.gap) || 24;
      return cards[0].offsetWidth + gap;
    };

    const maxIndex = () => Math.max(0, cards.length - Math.floor(getSPV()));

    // Build dots
    const buildDots = () => {
      dotsWrap.innerHTML = '';
      const total = maxIndex() + 1;
      for (let i = 0; i < total; i++) {
        const dot = document.createElement('button');
        dot.className = 'sp-dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', `スライド ${i + 1}`);
        dot.addEventListener('click', () => goTo(i));
        dotsWrap.appendChild(dot);
      }
    };

    const updateDots = () => {
      dotsWrap.querySelectorAll('.sp-dot').forEach((d, i) => {
        d.classList.toggle('is-active', i === current);
      });
    };

    const goTo = (index) => {
      current = Math.max(0, Math.min(index, maxIndex()));
      track.style.transform = `translateX(-${current * getCardW()}px)`;
      updateDots();
      if (prevBtn) prevBtn.disabled = current === 0;
      if (nextBtn) nextBtn.disabled = current >= maxIndex();
    };

    const updateNav = () => {
      const needsScroll = cards.length > Math.floor(getSPV());
      if (prevBtn) prevBtn.style.display = needsScroll ? '' : 'none';
      if (nextBtn) nextBtn.style.display = needsScroll ? '' : 'none';
      dotsWrap.style.display = needsScroll ? '' : 'none';
    };

    buildDots();
    updateNav();
    goTo(0);

    if (prevBtn) prevBtn.addEventListener('click', () => goTo(current - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => goTo(current + 1));

    window.addEventListener('resize', () => { buildDots(); updateNav(); goTo(0); });
  }

  // Support finder accordion
  document.querySelectorAll('.support-finder__item[data-accordion]').forEach((item) => {
    const trigger = item.querySelector('.support-finder__trigger');
    const content = item.querySelector('.support-finder__content');
    if (!trigger || !content) return;

    trigger.addEventListener('click', () => {
      const isOpen = item.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', isOpen);
      content.setAttribute('aria-hidden', !isOpen);
      content.style.maxHeight = isOpen ? content.scrollHeight + 'px' : '0';
    });
  });

  // Parent Notices Slider (desktop when posts > 3, OR always on mobile/SP)
  const noticeWrap = document.querySelector('.parents-notices--slider .parents-notices__wrap, .parents-notices--slider-sp .parents-notices__wrap');
  if (noticeWrap) {
    const grid  = noticeWrap.querySelector('.parents-notices__grid');
    const prev  = noticeWrap.querySelector('.parents-notices__nav--prev');
    const next  = noticeWrap.querySelector('.parents-notices__nav--next');
    const dots  = noticeWrap.querySelector('.parents-notices__dots');
    if (grid && prev && next) {
      const cards = Array.from(grid.querySelectorAll('.notice-card'));

      const getStep = () => {
        const card = grid.querySelector('.notice-card');
        if (!card) return 300;
        const gap = parseFloat(getComputedStyle(grid).gap) || 0;
        return card.offsetWidth + gap;
      };

      const updateBtns = () => {
        prev.disabled = grid.scrollLeft <= 0;
        next.disabled = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 1;
      };

      // Build dots — one per card
      const dotEls = [];
      if (dots && cards.length > 0) {
        dots.innerHTML = '';
        cards.forEach((card, i) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', `スライド ${i + 1}`);
          b.addEventListener('click', () => {
            const step = getStep();
            grid.scrollTo({ left: step * i, behavior: 'smooth' });
          });
          dots.appendChild(b);
          dotEls.push(b);
        });
      }

      const updateDots = () => {
        if (!dotEls.length) return;
        const step = getStep() || 1;
        const idx = Math.round(grid.scrollLeft / step);
        dotEls.forEach((d, i) => d.classList.toggle('is-active', i === idx));
      };

      const update = () => { updateBtns(); updateDots(); };

      prev.addEventListener('click', () => grid.scrollBy({ left: -getStep(), behavior: 'smooth' }));
      next.addEventListener('click', () => grid.scrollBy({ left: getStep(), behavior: 'smooth' }));
      grid.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
  }
});
